import React, {useState, useEffect, useContext } from "react";
/* import { useContext } from 'react'; */
import { CurrentUserContext } from '../../context/CurrentUserContext';
import "../ProfileSideBar/ProfileSideBar.css";
import levelContentData from '../Content/LevelContentData';
import profileIcon from '../../images/icons/profile-icon.png';
import profileIconWhite from '../../images/icons/profileW.svg';
import ProfilePictureUploader  from "./ProfilePictureUploader";
import EditProfileModal from "../EditProfileModal/EditProfileModal";
import ChangePasswordPopup from "../ChangePasswordPopup/ChangePasswordPopup";
import { useTranslation } from "../../utils/hooks/translateHook";



 const ProfileSidebar = ({  levelContentData = [], onEditProfile, onChangePassword }) => {
  const {currentUser , setCurrentUser} = useContext(CurrentUserContext);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const openEditModal = () => setEditModalOpen(true);
  const closeEditModal = () => setEditModalOpen(false);
  const [isPasswordModalOpen, setPasswordModalOpen] = useState(false);
  const openPasswordModal = () => setPasswordModalOpen(true);
  const closePasswordModal = () => setPasswordModalOpen(false);

  const t = useTranslation();


  const levelInfo = currentUser?.subscriptionLevel
  ? levelContentData.find(item => item.level === currentUser.subscriptionLevel)
  : null;
  const levelTitle = levelInfo?.title || 'Unknown';

/*   console.log("user", currentUser) */

  const formatDate =  currentUser?.createdAt
    ? new Date(currentUser.createdAt).toLocaleDateString('en-GB').replace(/\//g, '.')
    : '';  

  return (
    <div className="profile-sidebar">
      <div className="profile-info">
        {/* <img src={user.profilepicture || defaultPP} alt="Profile Picture" className="profile-pic" /> */}
        <ProfilePictureUploader 
          onImageUpload={(updatedUser) => { 
            setCurrentUser(prev => {
              const mergedUser = { ...prev, ...updatedUser };
              localStorage.setItem('user', JSON.stringify(mergedUser));
              return mergedUser;
            });
          }}
        />
        <h3 className="level-title">{t('greeting')} {currentUser?.name} !</h3>
        <div className="profile-iconContainer"><img src={profileIconWhite} className="profile-icon"/>PROFILE</div>
        <ul>
          <li>
            <span>{t('lastName')}</span> <p>{currentUser?.lastname || ''}</p>
          </li>
          <li>   
            <span>{t('memberSince')}</span><p>{formatDate}</p>
          </li>
          <li>
            <span>{t('email')}</span> <p className="email">{currentUser?.email || ''}</p>
          </li>
          <li>
            <span>{t('country')}</span> <p>{currentUser?.country || ''}</p>
          </li>
          <li>
            <span>{t('city')}</span> <p>{currentUser?.city || ''}</p>
          </li>
          <li>
          <span>{t('phone')}</span> <p>{currentUser?.phone || ''}</p>
          </li>
        </ul>
        
        <div className="profile-buttons">
          <button onClick={openEditModal}>{t('editProfile')}</button>
          {isEditModalOpen && <EditProfileModal isOpen={isEditModalOpen} onClose={closeEditModal} />}
          <button onClick={openPasswordModal}>{t('changePassword')}</button>
          {isPasswordModalOpen && <ChangePasswordPopup isOpen={isPasswordModalOpen} onClose={closePasswordModal} />}
        </div>
      </div>
    </div>
  )
}



export default ProfileSidebar;

